import { frontendURL } from '../../../../helper/URLHelper';

import SettingsWrapper from '../SettingsWrapper.vue';
import Index from './Index.vue';
import Detail from './Detail.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/glossary'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'glossary_wrapper',
          meta: {
            permissions: ['administrator', 'agent'],
          },
          redirect: to => {
            return { name: 'glossary_list', params: to.params };
          },
        },
        {
          path: 'list',
          name: 'glossary_list',
          meta: {
            permissions: ['administrator', 'agent'],
          },
          component: Index,
        },
        {
          path: ':glossaryId',
          name: 'glossary_detail',
          meta: {
            permissions: ['administrator', 'agent'],
          },
          component: Detail,
        },
      ],
    },
  ],
};
